import type { PlayerOwner } from "../features/payment/types";

export interface AuthStateSnapshot {
  readonly owner: PlayerOwner;
}

export type AuthStateListener = (snapshot: AuthStateSnapshot) => void;

export interface AuthState {
  getSnapshot(): AuthStateSnapshot;
  setOwner(owner: PlayerOwner): void;
  subscribe(listener: AuthStateListener): () => void;
}

export function createAuthState(owner: PlayerOwner): AuthState {
  let snapshot: AuthStateSnapshot = { owner };
  const listeners = new Set<AuthStateListener>();

  return {
    getSnapshot() {
      return snapshot;
    },
    setOwner(next) {
      if (
        snapshot.owner.ownerId === next.ownerId &&
        snapshot.owner.ownerKind === next.ownerKind
      ) {
        return;
      }
      snapshot = { owner: next };
      for (const listener of listeners) {
        listener(snapshot);
      }
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
